<template>
    <div>
        <VJoySelect v-model="model" :label="$t('profile.section.header.edit.experience.level.label')">
            <option v-for="level in experienceLevels" :key="level.value" :value="level.value">
                {{ level.label }}
            </option>
        </VJoySelect>
    </div>
</template>

<script setup lang="ts">
    import {useTranslation} from '#imports';
    import {VJoySelect} from '@maltjoy/core-vue';
    import {ExperienceLevel} from '~/types/domain/Profile';

    const model = defineModel<ExperienceLevel>({required: true});

    const {t} = useTranslation();
    const experienceLevels = Object.values(ExperienceLevel).map((level) => ({
        value: level,
        label: `${t(`profile.creation.completion.wizard.categorization.experienceLevel.label.v2.${level}`)} - ${t(
            `profile.creation.completion.wizard.categorization.experienceLevel.description.v2.${level}`,
        )}`,
    }));
</script>
